export function SkipLink() {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:rounded-full focus:bg-primary focus:px-4 focus:py-2.5 focus:text-sm focus:tracking-wide focus:text-primary-foreground focus:shadow-lg"
    >
      Skip to main content
    </a>
  );
}
